/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconPersonFilled/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function TysiaIconPersonFilled({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconPersonFilled",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "#323232"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconPersonFilled.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-2rEn0q': alignSelf,'--mt-2-2rEn0q': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-2rEn0q': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-2rEn0q': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-2rEn0q': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-2rEn0q': opacity,'--w-10-2rEn0q': typeof width === 'number' ? `${width}px` : width,'--h-11-2rEn0q': typeof height === 'number' ? `${height}px` : height,'--a-7-2rEn0q': isAnimated ? animation : "none",'--sd-8-2rEn0q': isAnimated ? strokeDashoffset : 0,'--sd-9-2rEn0q': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconPersonFilled.SvgPath"
  data-view-path={viewPath}
 d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
 style={{'--f-12-2rEn0q': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}